
import { Vue, Component, Prop } from 'vue-property-decorator';
import PushButtonBase from '@/ui/components/devices/devices/base/PushButtonBase/index.vue';
import OutputFieldBase from '@/ui/components/devices/devices/base/OutputFieldBase.vue';
import SliderBase from '@/ui/components/devices/devices/base/SliderBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import LabelUnitWrapper from '@/ui/components/devices/components/LabelUnitWrapper.vue';
import { State } from 'vuex-class';
import { IVariablesState } from '@/store/modules/measurements/types';
import { IDevice } from '@/types/devices.types';

/**
 * Component that represent MixingValve device
 */
@Component({
  components: {
    PushButtonBase,
    OutputFieldBase,
    SliderBase,
    DeviceLayout,
    LabelUnitWrapper,
  },
})
export default class MixingValve extends Vue {
  @Prop() deviceData!: IDevice;

  @State('measurements') measurementsState!: IVariablesState;

  get langPath() {
    return `devices.${this.deviceData.data.type}`;
  }

  get measurements() {
    return this.measurementsState.measurements;
  }
  get sliderActualValue() {
    return this.measurements.get(this.deviceData.data.mappings.OutputField_actualValue);
  }
}
